import flatpickr from "flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js"
import 'flatpickr/dist/themes/dark.css'

let commonOptions = {
  locale: French, // locale for this instance only
  altInput: true,
  time_24hr: true,
  // minDate: 'today',
  // nextArrow: '<i class="zmdi zmdi-long-arrow-right" />',
  // prevArrow: '<i class="zmdi zmdi-long-arrow-left" />'
}
let datetimeOptions = Object.assign({}, commonOptions, {
  enableTime: true,
  altFormat: "j F Y - H:i",
  dateFormat: 'Y-m-d H:i:ss',
})
let dateOptions = Object.assign({}, commonOptions, {
  enableTime: false,
  altFormat: "F j, Y",
  dateFormat: 'Y-m-d',
})
let timeOptions = Object.assign({}, commonOptions, {
  noCalendar: true,
  dateFormat: 'H:i',
  enableTime: true,
  altInput: false,
})

export default function (container = document) {
  let pickers = container.querySelectorAll('.datetime-picker, .date-picker, .time-picker')
  pickers.forEach((picker) => {
    let minDate = picker.hasAttribute('data-min-date') ? picker.getAttribute('data-min-date') :'today'
    let maxDate = picker.hasAttribute('data-max-date') ? picker.getAttribute('data-max-date') : null
    if (picker.classList.contains('datetime-picker')) {
      datetimeOptions['minDate'] = minDate
      datetimeOptions['maxDate'] = maxDate
      flatpickr(picker, datetimeOptions)
    } else if (picker.classList.contains('date-picker')) {
      dateOptions['minDate'] = minDate
      dateOptions['maxDate'] = maxDate
      flatpickr(picker, dateOptions)
    } else if (picker.classList.contains('time-picker')) {
      flatpickr(picker, timeOptions)
    }
  })
  // initialized above
  // *** DO NOT UNCOMMENT lines below
  // flatpickr('.datetime-picker', datetimeOptions)
  // flatpickr('.date-picker', dateOptions)
  // flatpickr('.time-picker', timeOptions)
}



// WEBPACK FOOTER //
// ./resources/assets/js/module/app.datetimepickers.js